import type { Capacity } from './dailyEngine'

export interface CapacityModeCopy {
  name: string
  mark: string
  selectorDetail: string
  quote: string
  acknowledgement: string
}

export const CAPACITY_MODES: Record<Capacity, CapacityModeCopy> = {
  low: {
    name: 'Hold the Line',
    mark: 'I',
    selectorDetail: 'Life is heavy. Keep the promise small and real.',
    quote: 'You came back while life was heavy. That is not weakness. That is a man refusing to abandon himself.',
    acknowledgement: 'Showing up with less to give still counts. Protect the smallest honest action and let that be enough for today.',
  },
  normal: {
    name: 'Stand Grounded',
    mark: 'II',
    selectorDetail: 'Present, steady and ready for meaningful work.',
    quote: 'Feet under you. Eyes open. Build with intention and let steady work become character.',
    acknowledgement: 'You have enough room to practise with purpose. No performance—just honest, repeatable work that strengthens the man you are becoming.',
  },
  spacious: {
    name: 'Forge Forward',
    mark: 'III',
    selectorDetail: 'Energy is available. Use the room and go deeper.',
    quote: 'You made the room and brought the fire. Honour it—go deeper, act boldly and turn capacity into character.',
    acknowledgement: 'This energy is worth using well. Lean into the work, stay honest and build something your future self and family can feel.',
  },
}
